// Import Swiper and styles
var swiper = new Swiper('.slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 1000,
    spaceBetween: 10,
    effect: 'cube',
    shadow: true,
    shadowOffset: 20,
    shadowScale: 0.94,
    slideShadows: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
});

//# sourceMappingURL=Maket-agency-swiper.d5c1261b.js.map
